import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors, media } from '../../../constants/style'

import { Column } from '../Grid'

const Wrapper = styled(Column).attrs({
  grow: 0,
})`
  color: ${colors.red};
  font-size: 2rem;
  font-weight: 100;
  line-height: 2.5rem;
  padding: 0 20px;
  position: relative;
  text-transform: uppercase;

  ${media.medium`
    font-size: 3rem;
    line-height: 3.5rem;
  `}

  &:after {
    background-color: ${colors.red};
    bottom: .2rem;
    content: '';
    height: 7px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
    ${media.medium`
      bottom: .4rem;
    `}
  }
`

const Title = ({ children }) => (
  <Wrapper>
    {children}
  </Wrapper>
)

Title.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
}

export default Title



// WEBPACK FOOTER //
// ./src/components/UI/Title/index.js